import {AfterViewInit, Component, Directive, Type, ViewChild, ViewContainerRef} from '@angular/core';
import {AppCoreModule} from "projects/soko-console-web-v2/src/app/core/modules/app.core.module";
import {FlexModule} from "@angular/flex-layout";
import {MatButton} from "@angular/material/button";
import {MatDivider} from "@angular/material/divider";
import {MatActionList, MatList, MatListItem, MatListSubheaderCssMatStyler} from "@angular/material/list";
import {MatIcon} from "@angular/material/icon";
import {PolicyArticleComponent} from "@features/support/policies/policy-article/policy-article.component";
import {FairUsagePolicyArticleComponent} from "@features/support/policies/articles/fair-usage-policy-article.component";
import {
  SupportTimesPolicyArticleComponent
} from "@features/support/policies/articles/support-times-policy-article.component";
import {
  TermsAndConditionsArticleComponent
} from "@features/support/policies/articles/terms-and-conditions-article.component";
import {PrivacyPolicyArticleComponent} from "@features/support/policies/articles/privacy-policy-article.component";
import {
  PayOutPolicyAndFrequencyArticleComponent
} from "@features/support/policies/articles/pay-out-policy-and-frequency-article.component";
import {
  ClientPayOutPolicyAndFrequencyArticleComponent
} from "@features/support/policies/articles/client-pay-out-policy-and-frequency-article.component";
import {
  PointOfSaleTermsOfServiceArticleComponent
} from "@features/support/policies/articles/point-of-sale-terms-of-service-article.component";
import {
  ProcessingSalesAndRefundsArticleComponent
} from "@features/support/policies/articles/processing-sales-and-refunds-article.component";
import {
  TradingOutsideOfLinkedPosArticleComponent
} from "@features/support/policies/articles/trading-outside-of-linked-pos-article.component";

interface Section {
  title: string,
  icon: string,
  content: Article[]
}

interface Article {
  title: string,
  description: string,
  component: Type<any>
}

@Directive({
  standalone: true,
  selector: '[appPolicyHost]'
})
export class PolicyHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}

@Component({
  selector: 'app-policies',
  standalone: true,
  imports: [
    AppCoreModule,
    FlexModule,
    MatButton,
    MatDivider,
    MatList,
    MatListItem,
    MatListSubheaderCssMatStyler,
    MatIcon,
    MatActionList,
    PolicyArticleComponent,
    PolicyHostDirective
  ],
  templateUrl: './policies.component.html',
  styleUrl: './policies.component.scss'
})
export class PoliciesComponent implements AfterViewInit{
  // private componentFactoryResolver= inject(ComponentFactoryResolver);

  protected sections: Section[] = [
    {
      title: 'General terms of service',
      icon: 'quick_reference',
      content: [
        {
          title: 'Terms & Conditions',
          description: 'Read our terms and conditions',
          component: TermsAndConditionsArticleComponent
        },
        {
          title: 'Privacy Policy',
          description: 'Read our privacy policy',
          component: PrivacyPolicyArticleComponent
        },
        {
          title: 'Fair Usage Policy',
          description: 'Read our fair usage policy',
          component: FairUsagePolicyArticleComponent
        },
        {
          title: 'Support and Turnaround Times Policy',
          description: 'Read our support and turnaround times policy',
          component: SupportTimesPolicyArticleComponent
        }
      ]
    },
    {
      title: 'Split payments and payment processing',
      icon: 'request_quote',
      content: [
        {
          title: 'Retailer pay-out policy',
          description: 'Allocating and processing pay-outs for retailers',
          component: PayOutPolicyAndFrequencyArticleComponent
        },
        {
          title: 'Client pay-out policy',
          description: 'Allocating and processing pay-outs for clients (landlords)',
          component: ClientPayOutPolicyAndFrequencyArticleComponent
        }
      ]
    },
    {
      title: 'Addon: Integrated point of sale',
      icon: 'point_of_sale',
      content: [
        {
          title: 'Point-of-sale terms of service',
          description: 'General terms of service for the integrated point of sale software',
          component: PointOfSaleTermsOfServiceArticleComponent
        },
        {
          title: 'Processing sales and refunds',
          description: 'How sales and refunds are processed',
          component: ProcessingSalesAndRefundsArticleComponent
        },
        {
          title: 'Trading outside of linked POS policy',
          description: 'Policy on trading outside of the linked point of sale system',
          component: TradingOutsideOfLinkedPosArticleComponent
        }
      ]
    }
  ]

  @ViewChild(PolicyHostDirective, {static: true}) policyHost!: PolicyHostDirective;

  protected selectedArticle = this.sections[0].content[0];
  //
  // @ViewChild('termsAndConditions') termsAndConditionsTemplate!: TemplateRef<any>;
  // @ViewChild('privacyPolicy') privacyPolicyTemplate!: TemplateRef<any>;
  // @ViewChild('fairUsagePolicy') fairUsagePolicyTemplate!: TemplateRef<any>;
  // @ViewChild('supportTimesPolicy') supportTimesPolicyTemplate!: TemplateRef<any>;
  // @ViewChild('templateContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
  //
  // private _templateMap!: { [key: string]: TemplateRef<any> };


  ngAfterViewInit(): void {
  //   this._templateMap = {
  //     termsAndConditions: this.termsAndConditionsTemplate,
  //     privacyPolicy: this.privacyPolicyTemplate,
  //     fairUsagePolicy: this.fairUsagePolicyTemplate,
  //     supportTimesPolicy: this.supportTimesPolicyTemplate
  //   };
  //   this.current(this.sections[0].content[0])
  }


  current(content: Article) {
    this.selectedArticle = content;
    // this.loadContent();
    this._loadComponent(content.component);
  }

  // loadContent() {
  //   const templateRef = this._templateMap[this.selectedArticle.template];
  //   if (templateRef) {
  //     this.container.clear();
  //     this.container.createEmbeddedView(templateRef);
  //   }
  // }

  private _loadComponent(component: Type<any>) {
    // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
    const viewContainerRef = this.policyHost.viewContainerRef;
    viewContainerRef.clear();
    viewContainerRef.createComponent(component);
  }
}
